// extracted by mini-css-extract-plugin
export default {"container":"LogoUpload_container__6Xecq","root":"LogoUpload_root__MCHn0","current-logo":"LogoUpload_current-logo__kWG5c","root__container":"LogoUpload_root__container__xC6bX"};